/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicCompanySummaryDto } from './publicCompanySummaryDto';
import { PublicLocationSummaryDto } from './publicLocationSummaryDto';
import { PersonalizationDto } from './personalizationDto';
import { PublicPlaceInformationDto } from './publicPlaceInformationDto';


export interface PublicLoyaltyProgramDetailDto { 
    id?: number;
    displayName?: string;
    logo?: string;
    currency?: string;
    priceToPointsRatio?: number;
    dailyLimit?: number;
    govQrCodeAvailable?: boolean;
    status?: PublicLoyaltyProgramDetailDto.StatusEnum;
    personalization?: PersonalizationDto;
    company?: PublicCompanySummaryDto;
    placeInformation?: PublicPlaceInformationDto;
    primaryLocation?: PublicLocationSummaryDto;
    showLocations?: boolean;
}
export namespace PublicLoyaltyProgramDetailDto {
    export type StatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const StatusEnum = {
        Invalid: 'INVALID' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Valid: 'VALID' as StatusEnum
    };
}


